import React from "react";
import { useNavigate } from "react-router-dom";
import headerLeft from "../../assets/images/home/headerLeft.webp"; 
import headerBg from '../../assets/images/backgrounds/headerBg.webp';
import { ROUTES_NAME } from "../../constants/routes";
import Button from "../../components/button/Button";

const Header = () => {
  const navigate = useNavigate();

  return (
    <div
      className="w-full bg-[#FFF9F3] bg-no-repeat bg-cover bg-center -z-10 pb-20"
      style={{ backgroundImage: `url(${headerBg})` }}
    >
      <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center justify-between px-4 md:px-12 py-16">
        {/* LEFT TEXT SECTION */}
        <div className="text-center md:text-left md:w-1/2 space-y-6">
          <h1 className="text-3xl md:text-5xl font-outfitRegular text-defaultText leading-normal md:leading-[70px]">
            TAKE YOUR{" "}
            <span className="text-primary-900 font-outfitSemiBold">
              COACHING
            </span>{" "}
            <br />
            TO <span className="font-outfitSemiBold">
              NEW HEIGHTS
            </span> WITH <br />
            <span className="text-primary-900 font-outfitSemiBold">
              REAL EXAM
            </span>{" "}
            REHEARSALS
          </h1>

          <p className="text-gray-700 max-w-md mx-auto md:mx-0 text-sm md:text-base">
            Equip your students with real exam simulations, instant results, and
            powerful analytics—transforming their preparation and boosting your
            institute's success.
          </p>

          <Button
            onClick={() => navigate(ROUTES_NAME.BOOK_A_DEMO)}
            variant="secondary"
          >
            BOOK A DEMO
          </Button>
        </div>

        {/* RIGHT IMAGE SECTION */}
        <div className="md:w-1/2 relative mb-12 md:mb-0">
          <img
            src={headerLeft}
            alt="Hero"
            loading="lazy"
            decoding="async"
            className="w-full max-w-xl aspect-[4/3] object-contain mx-auto md:ml-auto"
          />        
        </div>
      </div>
    </div>
  );
};

export default Header;
